import React from 'react'
import { WizardProvider } from '../../context'

export const Wizard = ({ children, ...rest }) => {
  return <WizardProvider {...rest}>{children}</WizardProvider>
}
